import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

// import pages
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Header from "./components/Header";
import Modal from "./components/Modal";

const App = () => {
  return <>
    <React.StrictMode>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="*" element={<Home />}/>
          <Route path="/contact" element={<Contact />}/>
          <Route path="/services/*" element={<Services />}/>
          <Route path="/portfolio/*" element={<Portfolio />}/>
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  </>
}

export default App;